<template>
    <!-- Start Copy Right Area  -->
    <div class="copyright-area">
			本网站全部服务由 Isafeclub LIMITED 独立运营、提供与维护，所有用户使用本网站、购买平台产品 / 订阅会员 / 接受安全服务，均与 Isafeclub LIMITED 建立服务法律关系。
		</div>
    <!-- End Copy Right Area  -->
</template>

<script>
    export default {
        name: 'Copyright'
    }
</script>
<style scoped lang="scss">
.copyright-area {
	padding: 15px 0;
	text-align: center;
	background-color: #000219;
	color: grey;
	font-size: 14px;
}
</style>
